import * as React from 'react';

export const StatusDiscussionTab = () => {
  return <div>TBA tab content: StatusDiscussionTab</div>;
};
